var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { CacheClient, CacheKeys, CacheLocation } from '../services/basics/client-caching.service';
import { SignalClientService } from '../services/basics/signal-client.service';
import { autoinject } from "aurelia-dependency-injection";
import { BaseWidget } from "./base-widget";
import { transient } from "aurelia-dependency-injection";
import { QueryFilterUriConverter } from "../views/components/converters/queries/query-filter";
import { InitFilterValueConverter } from "../views/components/converters/queries/init-filter";
import { QueriesClientService } from "../services/queries/queries-client.services";
import * as Enumerable from 'linq';
import { DialogServiceConstants } from "../constants/basics/dialog.constants";
import { DialogClientService } from "../services/basics/dialog-client.service";
var CountWidget = /** @class */ (function (_super) {
    __extends(CountWidget, _super);
    function CountWidget(initFilter, queriesService, signalClientService, cache, dialogClientService) {
        var _this = _super.call(this, signalClientService) || this;
        _this.initFilter = initFilter;
        _this.queriesService = queriesService;
        _this.cache = cache;
        _this.dialogClientService = dialogClientService;
        _this.isLoading = true;
        return _this;
    }
    Object.defineProperty(CountWidget.prototype, "numberLengthClass", {
        get: function () {
            var isModelWidth1 = this.model.width == 1;
            if (this.count && isModelWidth1 && this.count > 9999999)
                return 'number-count-8';
            if (this.count && isModelWidth1 && this.count > 999999)
                return 'number-count-7';
            if (this.count && isModelWidth1 && this.count > 99999)
                return 'number-count-6';
            if (this.count && isModelWidth1 && this.count > 9999)
                return 'number-count-5';
            if (this.count && isModelWidth1 && this.count > 999)
                return 'number-count-4';
            else
                return '';
        },
        enumerable: false,
        configurable: true
    });
    CountWidget.prototype.onActivate = function (model) {
        var _this = this;
        this.isLoading = true;
        this.title = model.title;
        this.color = model.color;
        this.model = model;
        this.applyCount(model.entityTypeUri, model.queryFilters, model).then(function (x) {
            _this.count = Math.round(x);
            _this.isNumberTooLong = _this.model.width == 1 && x > 999;
            _this.isLoading = false;
        });
    };
    CountWidget.prototype.applyCount = function (selectedModel, selectedFilters, model) {
        var _this = this;
        this.selectedModel = selectedModel;
        var promise = new Promise(function (resolve, reject) {
            if (!model.aggrigationProperty || model.aggrigationType == "count") {
                var uri = "odata/" + selectedModel;
                var converter = new QueryFilterUriConverter(_this.initFilter, selectedFilters, 0, 0, []);
                uri += converter.getUri(true);
                uri += "&$count=true&$top=0";
                _this.queriesService.getData(uri)
                    .then(function (res) {
                    var count = res["@odata.count"];
                    resolve(count);
                }).catch(function (error) {
                    reject(error);
                });
            }
            else {
                var url = "/odata/" + model.entityTypeUri.replace(/\s/g, "") + "/Genesis.GroupBy(column=" + (model.nameProperty && model.nameProperty.name.trim() != "" ? "'" + model.nameProperty.name + "'" : null) +
                    ",propertyForAggregation='" +
                    (model.aggrigationProperty ? model.aggrigationProperty.name : "") + "',aggregationType='" + model.aggrigationType + "')";
                var converterInitialFilters = new QueryFilterUriConverter(_this.initFilter, selectedFilters ? selectedFilters : [], 0, 1000, Enumerable.from(model.columns).where(function (x) { return x.isSortable; }).toArray());
                url = converterInitialFilters.getUri(true, true, url);
                url += "&$limit=1";
                _this.queriesService.getData(url)
                    .then(function (res) {
                    var count = res.value[0][Object.keys(res.value[0])[0]];
                    resolve(count);
                }).catch(function (error) {
                    reject(error);
                });
            }
        });
        return promise;
    };
    CountWidget.prototype.view = function () {
        this.cache.put(CacheKeys.selectedFilters, {
            queryFilters: this.model.queryFilters,
            columns: this.model.columns
        }, CacheLocation.SessionStorage);
        this.dialogClientService.show(DialogServiceConstants.URLs.ViewQueryDialog, { uri: this.selectedModel, title: this.title }, true, true);
    };
    CountWidget = __decorate([
        transient(),
        autoinject(),
        __metadata("design:paramtypes", [InitFilterValueConverter, QueriesClientService,
            SignalClientService, CacheClient,
            DialogClientService])
    ], CountWidget);
    return CountWidget;
}(BaseWidget));
export { CountWidget };
